import { IInventoryPage } from '../../inventory-page.interface';


export const USER_LOGIN_PAGE: IInventoryPage = {
	'route': '/user/login',
	'title': 'Login',
	'uiReference': [
		'Sign in',
		'Use your Flying account to continue.',
		'Dismiss message',
		'Enter email',
		'Enter password',
		'Open Flying website',
		'Open Flying Discord',
		'Open Flying YouTube',
		'Open Flying store',
		'Email',
		'Please enter email.',
		'Password',
		'Please enter password.',
		"Don't have an account? Create one",
		'Explore Flying',
		'Flying account sign in',
		'Appearance',
		'One secure account for Flying Research and Flying Upload'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/login/login.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/login/login.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-shell/auth-shell.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-shell/auth-shell.component.html'
	]
};
